import { Tutorial } from './tutorial';

export interface Exercise {
  id?: number;
  name: string;
  description: string;
  series?: any;
  muscleGroupId: number;
  muscleGroup?: string;
  gymMachineId: number;
  shortVideo?: any;
  tutorials?: Tutorial[];
}

// routineModelExercise
export interface RoutineModelExercise {
  id?: number;
  routineModelId: number;
  exercise?: Exercise;
  exerciseId: number;
  trainerComment: string;
  summary: string;
  internalExerciseGroupOrder?: number | null;
  exerciseGroup: number;
  reps: Rep[];

  //internal use
  intensityPrinciples?: string[];
  weightText?: string;
  repCount?: string;
}

export interface Rep {
  id?: number;
  quantity: number;
  seconds: number;
  weight?: number;
  weightKG?: number;
  serie: number;
  repsGroup: number;
  intensityPrinciples: string[];
}
